<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <sw-panel class="modal-template center-y">
      <span
        slot="header"
        class="flex center base-modal-title"
      >{{ dictionnary ? dictionnary.templateMenu.chargementTitre : ""}}</span>
      <div
        class="modal-template-content"
      >{{ dictionnary ? dictionnary.templateMenu.chargement : ""}}</div>
      <div>
        <div class="loading-simple flex center full">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="24px"
            height="30px"
            viewBox="0 0 24 30"
            style="enable-background:new 0 0 50 50;"
            xml:space="preserve"
          >
            <rect x="0" y="0" width="4" height="20" fill="#333">
              <animate
                attributeName="opacity"
                attributeType="XML"
                values="1; .2; 1"
                begin="0s"
                dur="0.6s"
                repeatCount="indefinite"
              ></animate>
            </rect>
            <rect x="7" y="0" width="4" height="20" fill="#333">
              <animate
                attributeName="opacity"
                attributeType="XML"
                values="1; .2; 1"
                begin="0.2s"
                dur="0.6s"
                repeatCount="indefinite"
              ></animate>
            </rect>
            <rect x="14" y="0" width="4" height="20" fill="#333">
              <animate
                attributeName="opacity"
                attributeType="XML"
                values="1; .2; 1"
                begin="0.4s"
                dur="0.6s"
                repeatCount="indefinite"
              ></animate>
            </rect>
          </svg>
        </div>
      </div>
    </sw-panel>
  </sw-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Loader from '@/components/loaders/Loader'

export default {
  name: 'TemplateModal',
  components: {
    Loader
  },
  beforeCreate() {},
  async created() {
    this.dictionnary = await this.getLanguages
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      dictionnary: null
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getLanguages'])
  },
  methods: {
    go() {
      this.$emit('close')
    }
  },
  watch: {}
}
</script>






// WEBPACK FOOTER //
// src/components/modal/TemplateLoadModal.vue